import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import {BootstrapVue, BootstrapVueIcons} from "bootstrap-vue"
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import MaterialKit from "./plugins/material-kit";


// установили для нашего токена заголовок Authorization в axios,
// чтобы наши запросы могли быть обработаны, со стороны сервера если токен потребуется
Vue.prototype.$http = Axios;
const token = 'Bearer ' + localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}


Vue.config.productionTip = false
Vue.use(MaterialKit);
Vue.use (BootstrapVue)
Vue.use (BootstrapVueIcons)
const NavbarStore = {
  showNavbar: false
};

Vue.mixin({
  data() {
    return {
      NavbarStore
    };
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
